import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import CameraForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  cameraListByFilter,
  cameraMutationSave,
} from '../../../shared/queries/Camera';
import { relationObjectListByParamsQuery } from '../../../shared/queries/RelationObject';
import { RELATION_OBJECT_TYPE } from '../../../shared/utils/constants';

const CameraFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({ id: 0, relatedObjects: [] });
  const [formOn, setFormOn] = useState(false);
  const [recipients, setRecipients] = useState([]);

  const backClickHandler = () => {
    history.push('/minime/configuracao-camera');
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };
  const loadRecipients = (selectedItems) => {
    showLoading();
    const query = relationObjectListByParamsQuery(false, false, true, true);
    GraphQL(query, {})
      .then((res) => {
        res.relationObjectListByParams = res.relationObjectListByParams
          .filter(
            (item) =>
              item.type.toUpperCase() !==
              RELATION_OBJECT_TYPE.STUDENT.toUpperCase()
          )
          .map((item) => ({
            ...item,
            value: item.identifier,
            label: item.description,
          }));
        const accesses = [];
        if (selectedItems) {
          selectedItems.forEach((item) => {
            res.relationObjectListByParams.forEach((relation) => {
              if (
                item.everyone &&
                relation.type.toUpperCase() ===
                  RELATION_OBJECT_TYPE.ALL.toUpperCase()
              ) {
                accesses.push(relation);
              } else if (
                item.schoolClass &&
                item.schoolClass.id === Number(relation.id)
              ) {
                accesses.push(relation);
              }
            });
          });
          dispatch(change('CameraForm', 'relatedObjects', accesses));
        }
        setRecipients(res.relationObjectListByParams);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const findById = (id) => {
    showLoading();
    const filter = {
      id,
    };
    const query = cameraListByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.cameraListByFilter) {
          setDto({
            ...res.cameraListByFilter[0],
          });
          const { accesses } = res.cameraListByFilter[0];
          loadRecipients(accesses);
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = (values) => {
    showLoading();
    const query = cameraMutationSave(values);
    GraphQL(query, {})
      .then(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
        backClickHandler();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        loadRecipients();
        setFormOn(true);
      }
    } else {
      loadRecipients();
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.camera-settings')}>
      {formOn && (
        <CameraForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          recipients={recipients}
        />
      )}
    </SmartCard>
  );
};

CameraFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CameraFormHandler)
);
